import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/form-provider';
import RHFTextArea from 'src/components/hook-form/rhf-text-area';
import { RHFUploadSingleFileFull } from 'src/components/hook-form/rhf-upload';
import { useMyDataStore } from 'src/store/me/me.store';

export interface OnboardingFormProps {
  methods: any;
  onSubmit: VoidFunction;
  handleDropUrl: (acceptedFiles: File[]) => void;
  handleRemove: (fileToRemove: string | File) => void;
  handleRemoveAll: () => void;
  isSubmitting: boolean;
  onboardingStagesFields: any;
  appendOnboardingStage: any;
  removeOnboardingStage: any;
  handleDropStepImage: (index: number, acceptedFiles: File[]) => void;
  handleRemoveStepImage: (index: number) => void;
  handleRemoveAllStepImages: () => void;
}
export default function OnboardingForm({
  methods,
  onSubmit,
  handleDropUrl,
  handleRemove,
  handleRemoveAll,
  isSubmitting,
  onboardingStagesFields,
  appendOnboardingStage,
  removeOnboardingStage,
  handleDropStepImage,
  handleRemoveStepImage,
  handleRemoveAllStepImages,
}: OnboardingFormProps) {

  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.personalization)

  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <Typography>Imagem Inicial do Onboarding:</Typography>
            <RHFUploadSingleFileFull
              name="startImage"
              accept={'image/*' as any}
              acceptAll={false}
              onDrop={handleDropUrl}
              onRemove={handleRemove}
              onRemoveAll={handleRemoveAll}
              showPreview
            />
            <RHFTextField name="startTitle" label="Título da tela inicial" />
            <RHFTextArea name="startDescription" label="Descrição da tela inicial" />
            <Typography>Passos do Onboarding:</Typography>
            {onboardingStagesFields.map((field: any, index: number) => (
              <Stack
                key={field.id}
                spacing={2}
                sx={{ border: '1px solid #ddd', p: 2, borderRadius: 2 }}
              >
                <Typography>Passo {index + 1} do Onboarding</Typography>
                <Typography variant="subtitle2">Imagem do passo {index + 1}:</Typography>
                <RHFUploadSingleFileFull
                  name={`onboardingSteps.${index}.stepImage`}
                  accept={'image/*' as any}
                  acceptAll={false}
                  onDrop={(files) => handleDropStepImage(index, files)}
                  onRemove={() => handleRemoveStepImage(index)}
                  onRemoveAll={handleRemoveAllStepImages}
                  showPreview
                />
                <RHFTextField name={`onboardingSteps.${index}.stepTitle`} label="Título do passo" />
                <RHFTextArea
                  name={`onboardingSteps.${index}.stepDescription`}
                  label="Descrição do passo"
                />
                {onboardingStagesFields.length > 1 && (
                  <Button color="error" onClick={() => removeOnboardingStage(index)}>
                    Remover Passo do Onboarding
                  </Button>
                )}
              </Stack>
            ))}
            <Stack direction="row" justifyContent="flex-start">
              <Button variant="soft" onClick={() => appendOnboardingStage(0)}>
                Adicionar Passo do onboarding
              </Button>
            </Stack>
            <Stack direction="row">
              <Box flexGrow={1} />
              <LoadingButton variant="contained" type="submit" loading={isSubmitting} disabled={!permissions?.update}>
                Salvar
              </LoadingButton>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </FormProvider>
  );
}
